export default __webpack_public_path__ + "static/media/scrabble-768w.01554d00.png";